module.exports = __webpack_public_path__ + "img/03.6c4c6f51.jpg";